// extracted by mini-css-extract-plugin
export default {"AddProjectsTagsDialog":"AddProjectsTagsDialog_AddProjectsTagsDialog__nFme2"};